/**
 * Maps product preference labels to their corresponding API keys
 */
function mapProductPreferencesToApiKeys(productPreferenceLabels: string[]): string[] {
  return productPreferenceLabels
    .map(label => {
      const normalised = label.toLowerCase();
      if (normalised.includes('lotto') || normalised.includes('lotter')) return 'lottery';
      if (normalised.includes('casino')) return 'casino';
      if (normalised.includes('sportsbook')) return 'sportsbook';
      return '';
    })
    .filter(Boolean);
}

export { mapProductPreferencesToApiKeys };
